export const SET_ALERT = 'ALERTS/SET_ALERT';
export const CLEAR_ALERT = 'ALERTS/CLEAR_ALERT';
export const REGISTER_ALERTBOX = 'ALERTS/REGISTER_ALERTBOX';
export const UNREGISTER_ALERTBOX = 'ALERTS/UNREGISTER_ALERTBOX';

export const SECTIONS_DELIMITER = '+';
export const ID_DELIMITER = '#';

export const setAlert =
    (message, theme = 'success', section = '') =>
    (dispatch, getState) => {
        const { alertBoxIds } = getState().alerts;
        let alertSection = section;

        if (section !== '') {
            const noAlertForSection =
                alertBoxIds.find((id) => {
                    const parts = id
                        .split(ID_DELIMITER)[0]
                        .split(SECTIONS_DELIMITER)
                        .find((part) => part === section);
                    return parts !== undefined;
                }) === undefined;

            if (noAlertForSection) {
                alertSection = '';
            }
        }

        dispatch({
            type: SET_ALERT,
            message,
            theme,
            section: alertSection,
        });
    };

export const clearAlert = () => ({
    type: CLEAR_ALERT,
});

export const registerAlertbox = (id) => ({
    type: REGISTER_ALERTBOX,
    id,
});

export const unregisterAlertbox = (id) => ({
    type: UNREGISTER_ALERTBOX,
    id,
});
